import styled from 'styled-components';

import { SkeletonBodyCopy, SkeletonHeadline } from '@xing-com/skeleton';
import { spaceM } from '@xing-com/tokens';

const StyledSkeletonHeadline = styled(SkeletonHeadline).attrs({
  size: 'large',
  amountRows: 1,
})`
  margin-bottom: ${spaceM};
`;

export const AiJobSummarySkeleton: React.FC = () => (
  <>
    <StyledSkeletonHeadline />
    <SkeletonBodyCopy />
  </>
);
